module Tapas.Bindings {
    export class FadeVisible {
        public init(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

            element = $(element);
            var value = valueAccessor();
            element.toggle(ko.unwrap(value)); // Use "unwrapObservable" so we can handle values that may or may not be observable
        }

        public update(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

            var value = valueAccessor();
            var delayIn = allBindingsAccessor.get('delayIn') || 0; // set a delay in
            var delayOut = allBindingsAccessor.get('delayOut') || 0; // set a delay out
            var duration = allBindingsAccessor.get('duration') || 'fast'; // set the fade in/out speed

            ko.unwrap(value) ? $(element).delay(delayIn).fadeIn(duration) : $(element).delay(delayOut).fadeOut(duration);

        }
    };
    ko.bindingHandlers['Fadevisible'] = new FadeVisible();
}
